module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1033-3ccb93b9bff7cded284a6a49a9344951.png";